module.exports = __webpack_public_path__ + "media/images/our_apps/roku_md-8a3ebf0be53e06aebfe887d050b438ef.png";